import React from 'react';
import { RefinementListConnectorParams } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { useRefinementList } from 'react-instantsearch';

type CheckboxGroupProps = RefinementListConnectorParams & { label: string };

const SearchFacet = (props: CheckboxGroupProps) => {
  const { items, refine } = useRefinementList(props);

  if (items.length === 0) return null;

  return (
    <div className="search-list__facet">
      <div className="search-list__facet-headline">
        <p className="typo-category">{props.label}</p>
      </div>

      <div className="search-list__checkbox-group">
        {items.map((i, index) => (
          <label key={i.value} className="search-list__checkbox">
            <input
              className="hide-visually"
              type="checkbox"
              onChange={() => refine(i.value)}
              id={`${props.attribute}-${index}`}
              name={props.attribute}
              value={i.value}
              checked={i.isRefined}
            />
            <span className="search-list__checkbox-custom" />

            {props.attribute === 'topic' ? (
              <span className="link link--greige typo-copy-large font-bold font-uppercase">
                {i.label}
              </span>
            ) : (
              <span className="tag tag--category">{i.label}</span>
            )}
          </label>
        ))}
      </div>
    </div>
  );
};

export default SearchFacet;
